<template>
    <div class="container">
        <!-- <div class="row filter_action mt-2">
            <div class="col-md-12 col-lg-6 col-xl-5 item item__key input-custom-icon mt-3">
                <input v-model.lazy="paramQueryData.keyword" v-debounce="300" type="text" placeholder="Tìm kiếm gì đó"
                    class="primary-color-txt color_bg_gray_light border-rd-20 font-size-15 form-h30 border-0 full-width">
                <i class="icon-search font-size-16 primary-color"></i>
            </div>
        </div> -->

        <div class="table_content mt-3">
            <b-table striped hover :fields="fieldsTableData" :items="listData" class="b-table-list">
                <template #head(name)="data">
                    <span class="col-table">{{ data.label }}</span>
                </template>
                <template #cell(classSchoolName)="row">
                    <router-link class="link-click text-primary"
                        :to="{ path: getPath, query: { id: row.item.id, name: row.item.classSchoolName, classId: row.item.classId } }">
                        {{ row.item.classSchoolName }}
                    </router-link>
                </template>
                <template #cell(totalExercise)="row">
                    {{ row.item.totalExercise }}
                </template>
                <template #cell(totalBGDT)="row">
                    {{ row.item.totalBGDT }}
                </template>
                <template #cell(totalKHBG)="row">
                    {{ row.item.totalKHBG }}
                </template>
                <template #cell(totalSubject)="row">
                    {{ row.item.totalSubject }}
                </template>
            </b-table>
        </div>
        <div class="row pagination container mb-3">
            <b-pagination pills v-model="paramQueryData.pageIndex" :total-rows="totalRecords"
                :per-page="paramQueryData.pageSize" first-number last-number></b-pagination>
        </div>
    </div>
</template>

<script>
import { getListClassSchoolMemberPersonal } from './../_api/lessonClassSchoolUserServices';
import debounce from "@/directives/debounce";
export default {
    directives: { debounce },
    props: {
        isReloadData: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            paramQueryData: {
                keyword: '',
                pageIndex: 1,
                pageSize: 5,
            },
            fieldsTableData: [
                { key: 'classSchoolName', label: 'Khối lớp', thClass: 'text-subtitle w-150px text-center', tdClass: 'w-150px text-center' },
                { key: 'totalExercise', label: 'Tổng số BT/BKT đã làm', thClass: 'text-subtitle text-center', tdClass: 'text-center' },
                { key: 'totalBGDT', label: 'Tổng số BGDT đã hoàn thành', thClass: 'text-subtitle text-center', tdClass: 'text-center' },
                { key: 'totalKHBG', label: 'Tổng số KHBD đã hoàn thành', thClass: 'text-subtitle text-center', tdClass: 'text-center' },
                { key: 'totalSubject', label: 'Tổng số môn', thClass: 'text-subtitle w-150px text-center', tdClass: 'w-150px text-center' }
            ],
            listData: [],
            totalRecords: 0
        }

    },
    computed: {
        getPath() {
            return '/chi-tiet-lop-hoc-trang-ca-nhan'
        }
    },
    watch: {
        'paramQueryData.pageIndex': 'getListClassMemberPersonal',
        'paramQueryData.keyword': 'getListClassMemberPersonal',
        'isReloadData': 'getListClassMemberPersonal'
    },
    mounted() {
        this.getListClassMemberPersonal()
    },
    methods: {
        getListClassMemberPersonal() {
            this.listData = []
            getListClassSchoolMemberPersonal(this.paramQueryData).then(res => {
                if (res && res.data && !res.errors && res.data.list != null) {
                    for (let i = 0; i < res.data.list.length; i++) {
                        const item = res.data.list[i];

                        this.listData.push({
                            'id': item.classSchoolId,
                            'classId': item.classId,
                            'classSchoolName': item.classSchoolId > 0 ? item.classSchoolName : '',
                            'totalExerciseAssigned': item.totalExerciseAssigned,
                            'totalExerciseCompleted': item.totalExerciseCompleted,
                            'totalBGDTAssigned': item.totalBGDTAssigned,
                            'totalBGDTCompleted': item.totalBGDTCompleted,
                            'totalKHBGAssigned': item.totalKHBGAssigned,
                            'totalKHBGCompleted': item.totalKHBGCompleted,
                            'totalSubject': item.totalSubject,
                            'totalExercise': `${item.totalExerciseCompleted || 0}/${item.totalExerciseAssigned || 0}`,
                            'totalBGDT': `${item.totalBGDTCompleted || 0}/${item.totalBGDTAssigned || 0}`,
                            'totalKHBG': `${item.totalKHBGCompleted || 0}/${item.totalKHBGAssigned || 0}`,
                        })
                    }
                    this.totalRecords = res.data.paging.totalRecords
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.b-table-list thead th,
.b-table-list tbody td {
    padding: 0.5rem;
    text-align: center;
}

.w-100px {
    width: 150px;
}

.input-custom-icon i {
    right: 15px;
}
</style>